// extracted by css-extract-rspack-plugin
export default {"restrictedAsset":"YWQ3VJ94oCAXtlzx","restrictedAssetMessageItem":"O69XSnOUPYmmjXVv"};